
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.228 15.4423C17.8654 15.805 17.2775 15.805 16.9148 15.4423L12 10.5275L7.08517 15.4423C6.72254 15.805 6.1346 15.805 5.77197 15.4423C5.40934 15.0797 5.40934 14.4918 5.77197 14.1291L11.3434 8.5577C11.706 8.19507 12.294 8.19507 12.6566 8.5577L18.228 14.1291C18.5907 14.4918 18.5907 15.0797 18.228 15.4423Z","fill":"#16171F"}})])
          )
        }
      }
    